export default "__VITE_ASSET__nFIMi8kO__"